<template>
  <div class="image-carousel">
    <div class="carousel-wrapper">
      <div v-for="(item, index) in currentImages">
        <div class="kuang" @click="tiao()">
          <img :src="item.imgurl" alt="" />
          <div>{{ item.mc }}</div>
        </div>
      </div>
    </div>
    <div class="control-buttons">
      <button class="z" @click="prevGroup">
        <img src="../assets/z.png" alt="" />
      </button>
      <button class="y" @click="nextGroup">
        <img src="../assets/y.png" alt="" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageCarousel",
  props: {
    images: {
      type: Array,
      required: true,
    },
    imagesPerGroup: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      currentGroupIndex: 0,
    };
  },
  computed: {
    currentImages() {
      const start = this.currentGroupIndex * this.imagesPerGroup;
      const end = start + this.imagesPerGroup;
      return this.images.slice(start, end);
    },
  },
  methods: {
    nextGroup() {
      const totalGroups = Math.ceil(this.images.length / this.imagesPerGroup);
      if (this.currentGroupIndex < totalGroups - 1) {
        this.currentGroupIndex++;
      } else {
        this.currentGroupIndex = 0; // 可选：循环回到第一组
      }
    },
    prevGroup() {
      if (this.currentGroupIndex > 0) {
        this.currentGroupIndex--;
      } else {
        const totalGroups = Math.ceil(this.images.length / this.imagesPerGroup);
        this.currentGroupIndex = totalGroups - 1; // 可选：循环到最后一组
      }
    },
    tiao() {
      this.$router.push("/sheshi");
      sessionStorage.setItem("insuranceCode", JSON.stringify(8));
      document.documentElement.scrollTop = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.kuang {
  margin-top: 30px;
  width: 380px;
  height: 270px;
  background: #ffffff;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
  img {
    margin-top: 20px;
  }
  a {
    text-decoration: none;
  }
  div {
    margin-top: 6px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
}
.image-carousel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.z {
  position: absolute;
  left: -10%;

  top: 35%;
}
.y {
  position: absolute;
  right: -10%;

  top: 35%;
}
.carousel-wrapper {
  display: flex;
  gap: 10px; /* 可选：图片之间的间距 */
}

.carousel-image {
  max-width: 300px; /* 可根据需要调整 */
  height: auto;
}

.control-buttons {
  display: flex;
  gap: 10px; /* 可选：按钮之间的间距 */
  margin-top: 20px; /* 可选：按钮与图片之间的间距 */
}

button {
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}
</style>
